import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Modal } from '../../atoms';
import styles from './drawer.styles';

/** @type {import('.').DrawerType} */
const Drawer = forwardRef(({ anchor = 'right', children, open, onClose = () => {}, mountContent = true, fluid, className, ...props }, ref) => {
  return (
    <Modal
      mountContent={mountContent}
      className={clsx(styles.drawer, styles.modalDrawer, {
        [styles.fluid]: fluid,
      })}
      open={open}
      onClose={onClose}
      ref={ref}
      {...props}
    >
      <Modal.Card
        padding="none"
        className={clsx(className, styles.drawerCard, {
          [`is-${anchor}`]: anchor,
          open,
        })}
      >
        {children}
      </Modal.Card>
    </Modal>
  );
});

export default Drawer;
